import axios from "../../config/axiosConfig";
import {
  VEHICLE_SALARY_REPORT_REQUEST,
  VEHICLE_SALARY_REPORT_SUCCESS,
  VEHICLE_SALARY_REPORT_FAILURE,
  VEHICLE_SALARY_REPORT_FILTER_REQUEST,
  VEHICLE_SALARY_REPORT_FILTER_SUCCESS,
  VEHICLE_SALARY_REPORT_FILTER_FAILURE,
  VEHICLE_SALARY_REPORT_PRINT_REQUEST,
  VEHICLE_SALARY_REPORT_PRINT_SUCCESS,
  VEHICLE_SALARY_REPORT_PRINT_FAILURE,
  VEHICLE_SALARY_REPORT_STATUS_REQUEST,
  VEHICLE_SALARY_REPORT_STATUS_SUCCESS,
  VEHICLE_SALARY_REPORT_STATUS_FAILURE
} from "../types/vehicle-salary-types";

export const getVehicleSalaryReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_SALARY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      const data = defaultParams;

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/vehicle-salary/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post("/vehicle-salary/getReport", data, { params: defaultParams }).then((response) => {
        console.log('<<<Vehicle Salary API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: VEHICLE_SALARY_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching vehicle salary Report:", error);
        dispatch({ type: VEHICLE_SALARY_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching vehicle salary Report:", error);
      dispatch({ type: VEHICLE_SALARY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getVehicleSalaryFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: VEHICLE_SALARY_REPORT_FILTER_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                // finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/vehicle-salary/getFilterDetail?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                    dispatch({ type: VEHICLE_SALARY_REPORT_FILTER_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching delivery Report:", error);
                dispatch({ type: VEHICLE_SALARY_REPORT_FILTER_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching delivery Report:", error);
            dispatch({ type: VEHICLE_SALARY_REPORT_FILTER_FAILURE, error: error.message });
        }
    };
};

export const getVehicleSalaryReportPrint = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_SALARY_REPORT_PRINT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      const data = defaultParams;

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/vehicle-salary/getReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post("/vehicle-salary/getReport", data, { params: defaultParams }).then((response) => {
        console.log('<<<Vehicle Salary API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: VEHICLE_SALARY_REPORT_PRINT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching vehicle salary Report:", error);
        dispatch({ type: VEHICLE_SALARY_REPORT_PRINT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching vehicle salary Report:", error);
      dispatch({ type: VEHICLE_SALARY_REPORT_PRINT_FAILURE, error: error.message });
    }
  };
};

export const updateVehicleSalaryStatus = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_SALARY_REPORT_STATUS_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      const requestParams = { ...defaultParams };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/vehicle-salary/updateStatus?${queryString}`;
      // Make API call
      return axios.post(fullUrl).then((response) => {
        // Dispatch success action with data
        dispatch({ type: VEHICLE_SALARY_REPORT_STATUS_SUCCESS });
        return response.data;
      }).catch((error) => {
        console.error("Error fetching vehicle salary Report:", error);
        dispatch({ type: VEHICLE_SALARY_REPORT_STATUS_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching vehicle salary Report:", error);
      dispatch({ type: VEHICLE_SALARY_REPORT_STATUS_FAILURE, error: error.message });
    }
  };
};

export const clearVehicleSalaryReport = () => {
  return async (dispatch) => {
        dispatch({ type: VEHICLE_SALARY_REPORT_SUCCESS, payload: {} });
  }
}
